import React, { useContext, useEffect, useRef, useState } from "react";
import Title from "../../new-components/title/Title";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ShowLaundry } from "../../API/LaundryAPI";
import ViewLaundryCartModal from "../../Components/ViewLaundryCartModal";
import { Accordion, AccordionTab } from "primereact/accordion";
import TaxInclusive from "../../Components/TaxInclusive.";
import { Button, Form } from "react-bootstrap";
import LaundryLoader from "../../Components/Loaders/LaundryLoader";
import BannerServices from "../../new-components/banner-home/BannerServices";
import "./HotelServices.scss";
import NewFooter from "../../NewFooter";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import axios from "../../axios";
import { object, string } from "yup";
import { Toast } from "primereact/toast";
import OtpModal from "../../Components/OtpModal";
import { ThemeContext } from "../../context/ThemeContext";
import HeaderInner from "../../Components/HeaderInner";
import { trackExternalServiceCategoryViewed } from "../../utils/mixpanel";

const LaundryService = () => {
  const toast = useRef(null);
  const location = useLocation();
  const params = useParams();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [errPhone, setErrPhone] = useState("");
  const [loading, setLoading] = useState();
  const [isDisabled, setIsDisabled] = useState();
  const [verificationCode, setVerificationCode] = useState();
  const [otpError, setOtpError] = useState();
  const [loadingVerifyOtp, setLoadingVerifyOtp] = useState(false);

  const [errorEmail, setErrorEmail] = useState("");
  const handleShow = () => {
    setShow(true);
  };
  const [laundaryOrder, setLaundaryOrder] = useState({
    name: "",
    email: "",
    phone: "",
  });

  let laundarySchema = object({
    name: string(),
    phone: string(),
    email: string().email(),
  });
  const laundry_uuid = params.laundry_uuid;
  const lang = localStorage.getItem("lang");
  const { t } = useTranslation();
  const navigate = useNavigate();
  let la;
  let images;
  let laundryId;
  let service_fee;
  let discount_percentage;
  let vat;
  let min_amount;
  let header_title;

  let use_banners_in_popup = false;
  const { data, isLoading } = ShowLaundry(params.room_uuid, laundry_uuid, lang);
  if (!isLoading) {
    if (data.data.status === false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else {
      la = data.data.data;
      images = la?.header_images;
      header_title = la?.header_title;
      use_banners_in_popup = la?.use_banners_in_popup;
      laundryId = la.laundry.id;
      vat = la.laundry.vat;
      min_amount = la.laundry.min_amount;
      service_fee = la.laundry.service_fee;
      discount_percentage = la.laundry.discount_percentage;
    }
  }
  const { theme } = useContext(ThemeContext);

  // Track External Service Category Viewed on mount
  // useEffect(() => {
  //   if (!isLoading && la) {
  //     trackExternalServiceCategoryViewed({
  //       service_type: "laundry",
  //     });
  //   }
  // }, [isLoading]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLaundaryOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const checkInputs = () => {
    if (laundaryOrder.phone.length === 0) {
      setErrPhone("The phone field is required.");
    } else {
      setErrPhone("");
    }

    if (
      laundaryOrder.email.length > 0 &&
      !/\S+@\S+\.\S+/.test(laundaryOrder.email)
    ) {
      setErrorEmail("The email must be a valid email address.");
    } else {
      setErrorEmail("");
    }
  };

  const checkValEmail =
    laundaryOrder.email.length > 0 && !/\S+@\S+\.\S+/.test(laundaryOrder.email);
  let checkPhone = false;

  if (laundaryOrder.phone === "") {
    checkPhone = false;
  } else {
    checkPhone = true;
  }

  const handleVerify = async (e) => {
    setLoadingVerifyOtp(true);
    axios
      .post(
        `/${room_uuid}/verify_otp`,
        { phone: laundaryOrder.phone, verification_code: verificationCode },
        {
          headers: {
            lang: lang,
          },
        },
      )
      .then((res) => {
        console.log("res", res);
        if (res.data.isSuccessful === false) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: t(`${res.data.message}`),
            life: 4000,
          });
          return setLoadingVerifyOtp(false);
        }
        if (res.data.isSuccessful) {
          setLoadingVerifyOtp(false);
          // setLaundryCart([]);
          // setShowOtp(true);
          axios
            .post(
              `/${room_uuid}/washmen/customer_data_to_link`,
              {
                phone: "+" + laundaryOrder.phone,
                email: laundaryOrder.email,
                name: laundaryOrder.name,
              },
              {
                headers: {
                  lang: lang,
                },
              },
            )
            .then((res) => {
              console.log("res", res);
              if (res.data.isSuccessful === false) {
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: t(`${res.data.message}`),
                  life: 4000,
                });
                return setLoadingVerifyOtp(false);
              }
              if (res.data.isSuccessful) {
                setLoadingVerifyOtp(false);
                // setLaundryCart([]);
                navigate(
                  `/${room_uuid}/hotel-services/laundry/${laundry_uuid}/washmen`,
                  {
                    state: {
                      metadata: {
                        washmenUrl: res.data.data,
                      },
                    },
                  },
                );
                setShowOtp(false);
              }
            })
            .catch((err) => {
              setLoadingVerifyOtp(false);
              // setOtpError(err);
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        return setLoadingVerifyOtp(false);
      });
  };

  const handleBook = async (e) => {
    e.preventDefault();

    checkInputs();
    if (!checkValEmail && checkPhone) {
      setLoading(true);
      const ordered = {
        phone: laundaryOrder.phone,
        email: laundaryOrder.email,
        name: laundaryOrder.name,
      };
      const anser = await laundarySchema.validate(ordered);
      // Dynamically create payload
      const payload = { phone: laundaryOrder.phone };
      if (laundaryOrder.email) {
        payload.email = laundaryOrder.email;
      }
      if (laundaryOrder.name) {
        payload.name = laundaryOrder.name;
      }
      if (!anser) return;
      axios
        .post(`/${room_uuid}/send_otp`, payload, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          setIsDisabled(false);

          console.log("res", res);
          if (res.data.isSuccessful === false) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: t(`${res.data.message}`),
              life: 4000,
            });
            setLoading(false);
          }
          if (res.data.isSuccessful) {
            setLoading(false);
            // setLaundryCart([]);
            setShowOtp(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setIsDisabled(false);
          console.log(err);
          setLoading(false);
        });
    }

    // navigate("/HCOrderPlaced");
  };

  if (
    laundry_uuid === "d006219c-0f7a-47a9-9f49-a2c99aca1d50" ||
    laundry_uuid === "74763037-c507-467c-88ae-6f32ee435c6f"
  ) {
    return (
      <div className={`${theme ? "food" : "bg-white"} pb-0`}>
        {" "}
        {theme ? (
          <Title title={header_title} />
        ) : (
          <HeaderInner headerName={header_title} />
        )}
        <Toast ref={toast} position="bottom-center" />
        {isLoading ? (
          <LaundryLoader />
        ) : (
          <main
            className="  p-3"
            style={{
              marginTop: theme ? "0px" : "70px",
              backgroundColor: "white",
            }}
          >
            <p
              style={{
                color: theme ? "white" : "black",
                textAlign: "center",
              }}
            >
              {t("provide laundry information")}
            </p>
            <Form onSubmit={handleBook}>
              <Form.Group
                className="mb-3 dark-placeholder"
                controlId="formBasicname"
              >
                {" "}
                <Form.Control
                  type="text"
                  placeholder={`${t(`Your Name (Optional)`)}`}
                  name="name"
                  value={laundaryOrder.name}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group
                className="mb-3 dark-placeholder"
                controlId="formBasicname"
              >
                <Form.Control
                  type="email"
                  placeholder={`${t(`Your Email (Optional)`)}`}
                  name="email"
                  // value={laundaryOrder.email}
                  onChange={handleInputChange}
                />
              </Form.Group>
              {errorEmail !== "" && (
                <span className="err_msg">{t(`${errorEmail}`)}</span>
              )}

              <Form.Group className="mb-3 w-100 ">
                <PhoneInputComponent
                  className="ml-4"
                  value={laundaryOrder.phone}
                  onChange={(phone) => {
                    setLaundaryOrder((prev) => ({
                      ...prev,
                      phone,
                    }));
                  }}
                />
              </Form.Group>
              {errPhone !== "" && (
                <span className="err_msg">{t(`${errPhone}`)}</span>
              )}
              <div className="spacer-10"></div>

              <div className="spacer-40"></div>
              <div className="padd-div text-center mt-3">
                <Button
                  type="submit"
                  className="reg-btn order-btn"
                  // onClick={handleBook}
                  disabled={isDisabled || loading}
                >
                  {`${t("verify")}`}
                </Button>
              </div>
            </Form>
            <OtpModal
              handleClose={() => setShowOtp(false)}
              onChange={(value) => setVerificationCode(value)}
              verificationCode={verificationCode}
              setVerificationCode={setVerificationCode}
              onClose={() => setShowOtp(false)}
              onVerify={handleVerify}
              showOtp={showOtp}
              error={otpError}
              loading={loadingVerifyOtp}
              phone={laundaryOrder.phone}
              email={laundaryOrder.email}
            />
          </main>
        )}
      </div>
    );
  }

  return (
    <div className="food pb-0">
      <Title title={header_title} />
      <main className=" pad-top-0">
        {isLoading ? (
          <LaundryLoader />
        ) : (
          <>
            <BannerServices headerImages={images} />
            <div className="full-div padd-div" style={{ marginTop: "45px" }}>
              <Button
                className="reg-btn big d-flex justify-content-center align-items-center laundary-add-btn"
                onClick={handleShow}
              >
                <i className="fa-solid fa-plus"></i>
                <span>{t("Add Item")}</span>
                <span></span>
              </Button>
              <div className="view-cart-body text-center">
                <h3 className="text-center">
                  <TaxInclusive />
                </h3>
              </div>
              <Accordion
                multiple
                expandIcon="fa fa-plus"
                collapseIcon="fa fa-minus"
                className="mb-4"
              >
                {la.laundry.disclaimers_name &&
                la.laundry.disclaimers_name?.length > 0 ? (
                  <AccordionTab
                    key={"Disclaimer"}
                    header={t("Disclaimer")}
                    disabled={false}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: la.laundry.disclaimers_name,
                      }}
                    />
                  </AccordionTab>
                ) : null}
                {la.laundry.taxiDisclaimer_name &&
                la.laundry.taxiDisclaimer_name !== "" ? (
                  <AccordionTab
                    key={"Disclaimer1"}
                    header={t("Disclaimer Name")}
                    disabled={false}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: la.laundry.taxiDisclaimer_name,
                      }}
                    />
                  </AccordionTab>
                ) : null}
                {la.laundry.termsAndCondition_name &&
                la.laundry.termsAndCondition_name !== "" ? (
                  <AccordionTab
                    key={"Disclaimer3"}
                    header={t("Terms and Conditions")}
                    disabled={false}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: la.laundry.termsAndCondition_name,
                      }}
                    />
                  </AccordionTab>
                ) : null}
              </Accordion>
            </div>
          </>
        )}
        <NewFooter />
        <ViewLaundryCartModal
          show={show}
          handleClose={handleClose}
          laundryId={laundryId}
          laundry_uuid={laundry_uuid}
          itemChange={null}
          vat={vat}
          service_fee={service_fee}
          discount_percentage={discount_percentage}
          min_amount={min_amount}
          data={data}
          images={images}
          use_banners_in_popup={use_banners_in_popup}
          theme={true}
        />
      </main>
    </div>
  );
};

export default LaundryService;
